import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { forwardRef, memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

type Props = {
  color?: string;
  size?: number;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
};

export const NavHeaderMoreButton = memo(
  forwardRef<TouchableOpacity, Props>(
    ({ style, color, size, onPress }, ref) => {
      const { rpx } = useResponsiveContext();
      return (
        <TouchableOpacity
          ref={ref}
          onPress={onPress}
          css={`
            align-items: center;
            justify-content: center;
            width: ${rpx(32)}px;
            height: ${rpx(32)}px;
          `}
          style={style}
        >
          <Icon
            name="more-vertical"
            size={size ?? rpx(24)}
            color={color ?? 'black'}
          />
        </TouchableOpacity>
      );
    },
  ),
);
